import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

export const AppAlert = ({
    caption,
    message,
    accept,
    onAcept,
    reject,
    onReject,
    onClose
}) => {
    return (
        <div className="dark-bg flx-cnt">
            <div className="alert-container">
                <div className="alert-row">
                    <div className="alert-caption">{caption}</div>
                    <div className="close-container">
                        <button className="close-alert" onClick={onClose}>
                            <FontAwesomeIcon icon={faClose} className="alert-icon" />
                        </button>
                    </div>
                </div>
                <div className="alert-row">
                    <div className="alert-text">{message}</div>
                </div>
                <div className="alert-row alert-buttons-container">
                    {accept &&
                        <button className="alert-button ok-button" onClick={onAcept}>
                            {accept}
                        </button>
                    }
                    {reject &&
                        <button className="alert-button canc-button" onClick={onReject}>
                            {reject}
                        </button>
                    }
                </div>
            </div>
        </div>
    )
}